// This component has been deprecated.
import Pagination from "./Pagination";
export default Pagination;
